import { render, staticRenderFns } from "./submit-success.vue?vue&type=template&id=1a722b1a&scoped=true&"
import script from "./submit-success.vue?vue&type=script&lang=js&"
export * from "./submit-success.vue?vue&type=script&lang=js&"
import style0 from "./submit-success.vue?vue&type=style&index=0&id=1a722b1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a722b1a",
  null
  
)

export default component.exports